export default __webpack_public_path__ + "fannie-mae-logo-dkblue.png?c359cce6e6505c558c0bb60082349dec";